
export const CREATE_FIRM_CARD_MUTATION = `
  mutation CreateFirmCard($object: firm_carts_insert_input!) {
    insert_firm_carts_one(object: $object) {
      id
      firm_id
      firm_cart_firstname
      firm_cart_lastname
      firm_cart_mail
      firm_cart_phone
      firm_cart_second_phone
      firm_cart_status
      firm_cart_title
      firm_cart_task
      firm_cart_description
      created_at
    }
  }
`;

export const UPDATE_FIRM_CARD_MUTATION = `
  mutation UpdateFirmCard($id: Int!, $set: firm_carts_set_input!) {
    update_firm_carts_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      firm_id
      firm_cart_firstname
      firm_cart_lastname
      firm_cart_mail
      firm_cart_phone
      firm_cart_second_phone
      firm_cart_status
      firm_cart_title
      firm_cart_task
      firm_cart_description
      created_at
    }
  }
`;

export const DELETE_FIRM_CARD_MUTATION = `
  mutation DeleteFirmCard($id: Int!) {
    delete_firm_carts_by_pk(id: $id) {
      id
    }
  }
`; 